import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { getDarkerColor, isDark } from "./colors";

export const getSubdomain = (req) => {
  let subdomain;
  if (req && req.headers && req.headers.host) {
    subdomain = req.headers.host.split(".")[0];

    if (subdomain && subdomain.includes("localhost")) {
      return "";
    }
    return subdomain;
  }
  return;
};

export const getIpAddr = (req) => {
  let ipAddr = "localhost";

  if (req && req.headers) {
    ipAddr = req.headers["x-real-ip"] || req.connection.remoteAddress;
  }

  return ipAddr;
};

export const setShopTheme = (shop, theme) => {
  let finalTheme = theme;

  if (shop && shop.vendor) {
    const darkMode = isDark(shop.background_color);
    finalTheme = createTheme({
      ...theme,
      bordered: shop.bordered,
      palette: {
        ...theme.palette,
        // palette attr to get dark mode
        mode: darkMode ? "dark" : "light",
        primary: {
          main: shop.background_color,
        },
        secondary: {
          main: shop.accent_color,
        },

        // main theme color; picks the darker of both background/accent
        accent: {
          main: getDarkerColor(shop.background_color, shop.accent_color),
        },

        accentText: darkMode
          ? {
              primary: "#fff",
              secondary: "rgba(255, 255, 255, 0.7)",
              disabled: "rgba(255, 255, 255, 0.5)",
            }
          : {
              primary: "rgba(0, 0, 0, 0.87)",
              secondary: "rgba(0, 0, 0, 0.6)",
              disabled: "rgba(0, 0, 0, 0.38)",
            },
        // // button colors
        // action: darkMode
        //   ? {
        //       active: "#fff",
        //       hover: "rgba(255, 255, 255, 0.08)",
        //       selected: "rgba(255, 255, 255, 0.16)",
        //       disabled: "rgba(255, 255, 255, 0.3)",
        //       disabledBackground: "rgba(255, 255, 255, 0.12)",
        //     }
        //   : {
        //       active: "rgba(0, 0, 0, 0.54)",
        //       hover: "rgba(0, 0, 0, 0.04)",
        //       selected: "rgba(0, 0, 0, 0.08)",
        //       disabled: "rgba(0, 0, 0, 0.26)",
        //       disabledBackground: "rgba(0, 0, 0, 0.12)",
        //     },
      },
    });
  }

  return responsiveFontSizes(finalTheme);
};

export const getRandomInt = (min = 1, max = 1) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};
